import React, { Component, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import PaymentCardLists from "../payment-card-lists/PaymentCardLists";
import AddCreditCardForm from "../AddCreditCardForm";
import AddCheckForm from "../AddCheckForm";
import { getPayerAccount, getSelectedPrimaryAccount, getSelectedSecondaryAccount } from "../../../selectors/Selectors";
import { toast } from 'react-toastify';
import {
    addPaymentMethod, buildCardinalData,
    buildCCRequest, buildECRequest, cardFormToUpdateObject, checkFormToUpdateObject,
    getPaymentAccessToken,
    getPaymentResponse,
    getPaymetricResponse, updatePaymentMethod
} from "../../../requests/TokenRequests";
import { getPayerDetailsBuilder } from "../../../actions/InvoiceActions";
import { addSessionCard, addSessionCheck, updateSessionCard, updateSessionCheck } from "../../../reducers/PaymentReducer";
import { runWithGlobalLoader } from "../../../actions/CommonActions";
import { FormattedMessage } from 'react-intl';
import moment from "moment";
import { useCurrencyKey } from "../../../selectors/ConfigSelectors";
import { RootState } from "../../../reducers/RootReducer";
import { finalizePaymentMethodAndRefresh } from "./FinalizePaymentProcess";
import { PaymentOption } from "../../../interfaces/CnbsConfigInterfaces";
import { getAndClearSessionStorage, getPreAuthAmount } from "../../../utils";
import axios from '../../../axios';
import { cacheThreeDSFlowContext, clearThreeDSFlowContext } from "../../../threeDSFlowContext";

export const PAYMENT_METHOD_DEFAULT = "PAYMENT_METHOD_DEFAULT";
export const PAYMENT_METHOD_SAVE = "PAYMENT_METHOD_SAVE";

export function ManagePaymentMethods(props: any) {
    const [state, setState] = useState<{
        type: 'EC' | 'CC',
        editingPayment: any,
        isEditing: boolean,
    }>({
        type: 'CC',
        editingPayment: null,
        isEditing: false,
    });
    const currency_key = useCurrencyKey();
    const secure_3ds_enabled = useSelector<RootState, any>(state => state.app.config.sap?.data?.payment_provider[0]?.secure_3ds_enabled === "X");
    const secure_3ds_version = useSelector<RootState, any>(state => state.app.config.sap?.data?.payment_provider[0]?.secure_3ds_version);
    const dispatch = useDispatch();
    const payer = useSelector<any, any>(getPayerAccount);
    const primaryAccount = useSelector<any, any>(getSelectedPrimaryAccount);
    const secondaryAccount = useSelector<any, any>(getSelectedSecondaryAccount);
    const currentUser = useSelector<any, any>(state => state.default.currentUser);
    const config_payment_cards = useSelector<RootState, PaymentOption[]>(state => state?.app?.config?.sap?.data.payment_cards ?? []);

    function addPaymentMethodComponent() {
        setState({ ...state, editingPayment: {}, isEditing: false });
    }

    function onTabChange(type) {
        setState({ ...state, type: type });
        // props.setEditingPayment(null);
    }

    function isEC() {
        return state.type === 'EC';
    }

    function isCC() {
        return state.type === 'CC';
    }

    function onCardConfirmed(payment_card) {
        setState({ ...state });
        // props.setEditingPayment(null);
    }

    const editPayment = function (payment) {
        setState({
            ...state,
            editingPayment: payment,
            isEditing: true,
        });
    };

    async function saveCard(card) {
        await processCard(card);
        props.getPayerDetailsBuilder(props.primaryAccount, props.secondaryAccount, props.currentUser.primary_account_type_id);
        setState({ ...state, editingPayment: null });
        handleDeleteIframe();
    }

    async function saveCheck(card) {
        await processCheck(card);
        props.getPayerDetailsBuilder(props.primaryAccount, props.secondaryAccount, props.currentUser.primary_account_type_id);
        setState({ ...state, editingPayment: null });
    }


    async function processCheck(card) {
        if (state.isEditing) {
            if (card.save_on_file) {
                let response = await updatePaymentMethod(
                    props.payerAccount.PrimaryAcct,
                    props.primaryAccount.CompanyCode,
                    checkFormToUpdateObject(card, state.editingPayment.payment_card_token),
                    card.make_default);
                return response;
            } else {
                props.updateSessionCheck(checkFormToUpdateObject(card, state.editingPayment.payment_card_token), props.payerAccount.PrimaryAcct);
            }
        } else {
            const { access_token, merchant_guid, paymetric_xi_url } = await getPaymentAccessToken('EC');
            let body = buildECRequest(card, merchant_guid, access_token);
            await getPaymetricResponse(paymetric_xi_url, body, "2.1.0");
            let { paymentcard } = await getPaymentResponse(access_token);
            // We don't want to do  pass payment card to props method
            if (card.save_on_file) {
                try {
                    await addPaymentMethod(props.payerAccount.PrimaryAcct, props.primaryAccount.CompanyCode, paymentcard, card.make_default);
                } catch (error: any) {
                    if (error.message_number === 74) {
                        let matches = error.message_string.match(/Payment card (CCINS) (.*) already exist, action ([0-9]*) not possible/);
                        toast.error(`${matches[2]} already exists.`, { position: toast.POSITION.TOP_RIGHT });
                    } else if (error.message_number === 76) {
                        let matches = error.message_string.match(/Payment card (CCINS) (.*) already assigned to account ([0-9]*)/);
                        toast.error(`${matches[2]} already assigned to account ${matches[3]}`, { position: toast.POSITION.TOP_RIGHT });
                    } else {
                        toast.error(error.message_string, { position: toast.POSITION.TOP_RIGHT });
                    }
                }
            } else {
                props.addSessionCheck(paymentcard, props.payerAccount.PrimaryAcct);
            }
            return paymentcard;
        }
    }

    async function processCard(card) {
        if (state.isEditing) {
            if (card.save_on_file) {
                let response = await updatePaymentMethod(
                    props.payerAccount.PrimaryAcct,
                    props.primaryAccount.CompanyCode,
                    cardFormToUpdateObject(card, state.editingPayment.payment_card_token),
                    card.make_default);
                return response;
            } else {
                props.updateSessionCard(cardFormToUpdateObject(card, state.editingPayment.payment_card_token), props.payerAccount.PrimaryAcct);
            }
        } else {
            return runWithGlobalLoader(dispatch, async () => {
                if (secure_3ds_enabled) {
                    sessionStorage.setItem(PAYMENT_METHOD_DEFAULT, JSON.stringify(card.make_default));
                    sessionStorage.setItem(PAYMENT_METHOD_SAVE, JSON.stringify(card.save_on_file));
                    cacheThreeDSFlowContext({
                        flowType: "add-card",
                        primaryAccountId: primaryAccount?.PrimaryAcct,
                        secondaryAccountId: secondaryAccount?.PrimaryAcct ?? null,
                        saveOnFile: card.save_on_file,
                        makeDefault: card.make_default,
                        returnPath: window.location.pathname,
                    });
                }
                try {
                    const send_cardinal: boolean = secure_3ds_enabled && card.save_on_file;
                    const preauth_amount = getPreAuthAmount(card.card_type, config_payment_cards);
                    const cardinalData = buildCardinalData(preauth_amount, props.currentUser, props.payerDetails, secure_3ds_version, window.location.href, currency_key);
                    const { access_token, merchant_guid, paymetric_xi_url } = await getPaymentAccessToken('CC', send_cardinal ? cardinalData : {});
                    const clientIpResponse = await axios.get("/api/client-ip").catch(() => null);
                    const requestCardinalData = send_cardinal ? cardinalData : {};
                    let body = buildCCRequest(card, merchant_guid, access_token, currency_key, requestCardinalData, clientIpResponse);
                    await getPaymetricResponse(paymetric_xi_url, body, secure_3ds_version);

                    getAndClearSessionStorage(PAYMENT_METHOD_DEFAULT, false);
                    getAndClearSessionStorage(PAYMENT_METHOD_SAVE, false);
                    clearThreeDSFlowContext();
                    await finalizePaymentMethodAndRefresh(access_token, dispatch, payer, primaryAccount, secondaryAccount, currentUser, card.save_on_file, card.make_default);
                } catch (error) {
                    clearThreeDSFlowContext();
                    throw error;
                }
            });
        }
    }

    function deletePayment(payment) {
        if (state.editingPayment && payment.payment_card_token === state.editingPayment.payment_card_token) {
            setState({ ...state, editingPayment: null });
        }
    }

    function handleDeleteIframe() {
        var frame = document.querySelector('#cardinal_iframe_post')!;
        if (frame !== null) {
            frame.remove();
        }
    }

    function managePaymentsMethodAddClick(event) {
        handleDeleteIframe();
        addPaymentMethodComponent();
    }

    return <React.Fragment>
        <div className="row">
            <div className="col-md-6">
                <PaymentCardLists onTabChange={onTabChange} onEdit={editPayment}
                    onDelete={deletePayment} />
                <div className={"text-center mt-3"}>
                    {isCC() &&
                        <button className={"btn btn-primary"} onClick={managePaymentsMethodAddClick}><FormattedMessage
                            id={"payment_methods.add_card_button"} /></button>}
                    {isEC() &&
                        <button className={"btn btn-primary"} onClick={addPaymentMethodComponent}><FormattedMessage
                            id={"payment_methods.add_check_button"} /></button>}
                </div>
            </div>
            <div className="col-md-6">
                {(state.editingPayment && isCC()) &&
                    <AddCreditCardForm payment={state.editingPayment} save={saveCard}
                        isEditing={state.isEditing}
                        onCardConfirmed={onCardConfirmed}
                        alwaysSaveOnFile={props.alwaysSaveOnFile} />}
                {(state.editingPayment && isEC()) &&
                    <AddCheckForm payment={state.editingPayment} isEditing={state.isEditing}
                        onCardConfirmed={onCardConfirmed} save={saveCheck}
                        alwaysSaveOnFile={props.alwaysSaveOnFile} />}
            </div>
        </div>
    </React.Fragment>

}

export default connect<any, any, any, any>((state, props) => {
    return {
        payerAccount: getPayerAccount(state),
        primaryAccount: getSelectedPrimaryAccount(state),
        secondaryAccount: getSelectedSecondaryAccount(state),
        currentUser: state.default.currentUser,
        payerDetails: state.default.payerDetails,
    }
}, {
    getPayerDetailsBuilder,
    updateSessionCheck,
    addSessionCheck,
    updateSessionCard,
    addSessionCard,
})(ManagePaymentMethods)
